import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ApplicationLinkExpired: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            backgroundColor: '#f8f9fa'
          }}
        >
          <ErrorOutlineIcon 
            sx={{ 
              fontSize: 64, 
              color: 'warning.main',
              mb: 2 
            }} 
          />
          <Typography variant="h5" component="h1" gutterBottom align="center">
            Application Link Expired
          </Typography>
          <Typography variant="body1" align="center" color="text.secondary">
            This application link has expired or is no longer active. If you believe this is an error, please contact the administrator.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default ApplicationLinkExpired;
